import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/remen', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex items-center gap-2 no-underline">
            <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
              韩漫漫画网
            </span>
          </Link>
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-accent-500 ${
                  location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                    ? 'text-accent-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-foreground-700 text-lg"></i>
          </button>
          <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-200 transition-colors cursor-pointer" aria-label="用户">
            <i className="ri-user-line text-foreground-700 text-lg"></i>
          </button>
          <Link
            to="/category/remen"
            className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            开始阅读 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-foreground-700 text-lg ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium py-2 whitespace-nowrap ${
                location.pathname === link.to || (link.to !== '/' && location.pathname.startsWith(link.to))
                  ? 'text-accent-500'
                  : 'text-foreground-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category/remen"
            className="bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium text-center whitespace-nowrap mt-2"
          >
            开始阅读
          </Link>
        </div>
      )}
    </nav>
  );
}